









import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: { AdminIframe, PageTitle },
})
export default class ConditionRegistrationIframe extends Vue {
  private showIframe = process.env.VUE_APP_NODE_ENV !== 'production';
  
  private get isEditMode(): boolean {
    return this.$route.meta.mode === 'edit';
  }

  private get remoteSrc() {
    // 프리미엄 원주소(등록) : /promotion/free-gift/condition/add
    // 프리미엄 원주소(수정) : /promotion/free-gift/condition/edit/{conditonNo}
    const query = this.$route.query;
    const queryObject = { serviceType: 'PREMIUM', ...query };
    const queryString = new URLSearchParams(queryObject).toString();

    const path = this.isEditMode? `/promotion/free-gift/condition-edit/${this.$route.params.conditionNo}` : '/promotion/free-gift/condition-add'

    return process.env.VUE_APP_ADMIN_REMOTE_URL + path + '?' + queryString;
  }
}
